import { SliderImage } from 'entities/Photo/interfaces';
import { Actions } from './actions';
import {
  CLEAR_REPORT_PHOTO,
  GET_REPORT_TRIP_ERROR,
  GET_REPORT_TRIP_REQUEST,
  GET_REPORT_TRIP_SUCCESS,
} from './constants';

const initialState = {
  pictures: [] as SliderImage[],
  loading: false as boolean,
  error: null as Error | null,
};

export type TripState = typeof initialState;

export const reportPhotoReducer = (state: TripState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_REPORT_TRIP_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_REPORT_TRIP_SUCCESS: {
      return {
        ...state,
        pictures: action.payload,
        loading: false,
        error: null,
      };
    }
    case GET_REPORT_TRIP_ERROR: {
      return {
        ...state,
        pictures: [],
        loading: false,
        error: action.payload,
      };
    }
    case CLEAR_REPORT_PHOTO: {
      return {
        ...state,
        pictures: [],
        loading: false,
        error: null,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};
